import React from "react";
import { Navigate, useParams } from "react-router-dom";

const PatientProfileEditRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/patient/${id}`} replace />;
};

export default PatientProfileEditRedirect;
